<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 sticky top-0 uppercase bg-gray-50 z-20">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50 z-10"
      >
        <!-- id -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div class="text-base font-semibold">
            {{ "RCD-" + row["id"] }}
          </div>
        </td>

        <!-- setor responsável -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <div class="px-1 uppercase">
            <div class="text-base font-semibold">
              {{ row["relatoCompe"] }}
            </div>
          </div>
        </th>

        <!-- status -->
        <td class="px-6 py-4 uppercase">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full me-2"
              :class="[
                row['status'] === 'crítico' || row['status'] === null
                  ? 'bg-red-500'
                  : '',
                row['status'] === 'controlado' ? 'bg-yellow-500' : '',
                row['status'] === 'resolvido' ? 'bg-green-500' : '',
                row['status'] === 'cancelado' ? 'bg-gray-500' : '',
              ]"
            ></div>
            {{
              row["status"] == "crítico"
                ? "não controlado"
                : row["status"] ?? "não controlado"
            }}
          </div>
        </td>

        <!-- classificação -->
        <td scope="row" class="px-0 py-2 whitespace-nowrap">
          <div class="font-normal text-gray-500 uppercase">
            <label class="text-gray-700 text-sm">
              <strong>
                <section
                  class="lowercase"
                  :class="[
                    row.riskClassification == 'Risco Alto'
                      ? 'text-red-500'
                      : '',
                    row.riskClassification == 'Risco Moderado/Alto'
                      ? 'text-red-400'
                      : '',
                    row.riskClassification == 'Risco Substancial'
                      ? 'text-red-600'
                      : '',
                    row.riskClassification == 'Risco Crítico'
                      ? 'text-red-700'
                      : '',
                  ]"
                >
                  <span class="mt-auto flex justify-center">
                    {{ row.riskClassification }}
                  </span>
                  <div class="w-full flex justify-center">
                    <div v-for="item in row.riskSkulls" :key="item">
                      <img :src="iconSkull" class="w-6 h-6" />
                    </div>
                  </div>
                </section>
              </strong>
            </label>
          </div>
        </td>

        <!-- empresa relatada -->
        <td class="px-1 md:px-6 py-4 ml-auto mr-auto uppercase">
          {{ row["relatoEmpresa"] }}
        </td>

        <!-- ações -->
        <td class="py-4 sticky -right-1 bg-white">
          <div class="flex justify-center font-medium">
            <!-- Tomar ação -->
            <a
              title="Detalhes do relato"
              class="text-green-600 mr-1 cursor-pointer"
              @click="openModal(data[index])"
            >
              <component :is="PhFileText" class="h-7 w-7 md:h-6 md:w-6" />
            </a>

            <!-- Remover documento -->
            <a
              title="Desativar relato"
              class="text-red-600 ml-1 cursor-pointer"
              @click="deleteDoc(row['id'])"
            >
              <component :is="PhTrash" class="h-7 w-7 md:h-6 md:w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { PhFileText, PhTrash } from "@phosphor-icons/vue";
import { dataRcd } from "../../store";
import { defineProps } from "vue";

const iconSkull = require("@/assets/skull.webp");

const props = defineProps({
  data: [Object, Array],
});

const emit = defineEmits(["delete"]);

function deleteDoc(doc, id) {
  emit("delete", doc, id);
}

function openModal(data) {
  dataRcd.dispatch("setModalActive", data);
}
</script>
